import {Injectable} from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import {Observable} from "rxjs";
import {AuthService} from "../../modules/auth/services/auth-service";

@Injectable({
  providedIn: `root`
})
export class AutenticacaoGuard implements CanActivate{
  constructor(private tokenService: AuthService,
              private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const estaAutorizado = this.estaAutorizado();

    if(estaAutorizado)
      return true;
    else{
      this.tokenService.logoff();
      this.router.navigate([`/auth/login`]);
      return false;
    }
  }

  private estaAutorizado(): boolean{
    const token = this.tokenService.AccessToken;

    if(token === undefined || token === null || token.accessToken === ``){
      return false;
    }

    if(token.bloqueio.toLowerCase() == `true`)
      return false;

    const dataHoje = new Date(Date.now());
    if(dataHoje >= new Date(token.expires))
      return false;

    return true;
  }
}
